<template>
  <div class="exam">
    <div class="exam-detail">
      <h1 class="head">
        <template v-if="type === 'BDC'">{{wordExamData.navigation}}</template>
        <template v-else>{{caption}}</template>
      </h1>
      <div :class="{hide: printType === 'answer'}" class="info">
        姓名： <span class="unline"></span>
        成绩： <span class="unline"></span>
      </div>
      <div :class="{hide: printType === 'answer'}" class="exam-wrapper">
        <div class="bdc-exam" v-if="type === 'BDC'">
          <div class="item" v-for="(quiz, index) in wordExamData.quizzes" :key="index">
            <template v-if="quiz.code === 'DCPX'">
              <div class="question">
                <span>{{index + 1}}. </span>
                <span>{{quiz.explain}}</span>
              </div>
              <div class="blank">________________</div>
            </template>
            <template v-else-if="quiz.code === 'CHXZ'">
              <div class="chxz-question">
                <span>{{index + 1}}. </span>
                <span>{{quiz.text}}</span>
              </div>
              <div class="options" v-for="(option, number) in quiz.options" :key="number">
                {{numbers[number]}}.&nbsp;&nbsp;{{option}}
              </div>
            </template>
          </div>
        </div>
        <div ref="hk-exam" v-for="(exercise, index) in courseData.quizzes" :key="index">
          <component
            class="quizze"
            :is="quizzes[exercise.code]"
            :exercise="exercise"
            :is-done="false"
            :is-exam="false"
            :is-print="true"
            :is-show-number="true"
            :index="index">
          </component>
        </div>
      </div>
    </div>
    <div :class="{'display-answer': printType === 'answer'}" class="answer">
      <div>答案：</div>
      <template  v-if="type === 'BDC'">
        <span v-for="(quiz, index) in wordExamData.quizzes" :key="index">
          <span class="number">{{index + 1}}.</span>
          <span>
            <template v-if="quiz.code === 'DCPX'">{{quiz.text}}</template>
            <template v-else-if="quiz.code === 'CHXZ'">
              <template v-if="quiz.mode === 1">{{quiz.explain}}</template>
              <template v-else-if="quiz.mode === 2">{{quiz.text}}</template>
            </template>
            &nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </template>
      <span v-else v-for="(exercise, index) in courseData.quizzes" :key="index">
        <span class="number">{{index + 1}}.</span>
        <span
          v-if="exercise.code === 'DX'">
          {{numberToLetter(exercise.answerIndex)}}&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <span
          v-else-if="exercise.code === 'BQ'">
          <span v-for="(answer, index) in filterAnswer(exercise.text)" :key="index">
            {{answer}}&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </span>
      </span>
    </div>
    <el-button @click="printExam" type="primary" class="print-exam-btn">打印试卷</el-button>
    <el-button
      class="print-answer-btn"
      @click="openPasswordDialog"
      type="primary">
      打印答案
    </el-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { COURSE_DATA, FETCH_COURSE_DATA } from '@/store/learning/types';
import { Button, MessageBox } from 'element-ui';
import api from '@/api/graphql/englishCourse';
import DX from '@/components/quizzes/hk/DX.vue';
import BQ from '@/components/quizzes/hk/BQ.vue';
import utils from '@/services/utils';

const PASSWORD = 'xx2019';

export default {
  components: {
    ElButton: Button,
  },
  data() {
    return {
      quizzes: {
        DX,
        BQ,
      },
      numbers: ['A', 'B', 'C', 'D'],
      printType: 'exam',
      userPassword: '',
      type: '',
      wordExamData: {},
    };
  },
  computed: {
    ...mapGetters({
      courseData: COURSE_DATA,
    }),
    caption() {
      const subject = this.courseData.navigation ? this.courseData.navigation.split('-')[0] : '';
      const chapter = this.courseData.title ? this.courseData.title.split(' ')[0] : '';
      const section = this.courseData.subtitle ? this.courseData.subtitle.split(' ')[0] : '-';
      return `${subject}  ${chapter}  第${section}节`;
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    this.disableCopy();
  },
  methods: {
    ...mapActions({
      fetchCourseData: FETCH_COURSE_DATA,
    }),
    numberToLetter(index) {
      return ['A', 'B', 'C', 'D'][index];
    },
    filterAnswer(text) {
      return text.match(/(?<=\[\[)[^\]]*(?=]])/g);
    },
    getData() {
      const {
        type,
        quizType,
        courseId,
        unitId,
        mode,
        examType,
        examMode,
      } = this.$route.query;
      this.type = type;
      if (this.type === 'BDC') {
        api.getCourseData({
          courseId: Number(courseId),
          unitId: Number(unitId),
          type: quizType,
          examType,
          mode,
          examMode,
        }).then(({ englishCourseData }) => {
          this.wordExamData = englishCourseData;
        });
      } else {
        const options = {
          type: 'review',
          action: 'print',
          sectionId: this.$route.query.sectionId,
        };
        this.fetchCourseData({
          ...options,
        })
          .then(() => {});
      }
    },
    disableCopy() {
      /* eslint-disable */
      const el = window.document.body;

      el.oncontextmenu = ((e) => {
        e.preventDefault();
      });

      el.onselectstart = ((e) => {
        e.preventDefault();
      });

      el.oncopy = ((e) => {
        e.preventDefault();
      });

      el.onkeydown = ((e) => {
        if (e.ctrlKey) {
          return false;
        }
        if (e.altKey) {
          return false;
        }
        if (e.shiftKey) {
          return false;
        }
      });
    },
    openPasswordDialog() {
      MessageBox.prompt('请输入密码', '提示', {
        inputType: 'password',
        inputPlaceholder: '请输入密码',
        callback: this.printAnswer,
      })
    },
    printAnswer(action, instance) {
      if (action === 'confirm') {
        if (instance.inputValue === PASSWORD) {
          this.printType = 'answer';
          setTimeout(() => {
            window.print();
          }, 800);
        } else {
          utils.error('密码错误');
        }
      }
    },
    printExam() {
      this.printType = 'exam';
      this.$nextTick(() => {
        window.print();
      });
    },
  },
};
</script>

<style lang="scss">
  .exam {
    width: 100%;
    border:1px solid transparent;
    border-right: 0;
    border-left: 0;
    .head {
      margin-top: 20px;
      text-align: center;
      font-size: 28px;
    }
    .info {
      margin-top: 40px;
      text-align: center;
      .unline {
        display: inline-block;
        width: 80px;
        border-bottom: .8px #409EFF solid;
        vertical-align: sub;
      }
    }
    .exam-wrapper {
      width: 960px;
      margin: 20px auto 0;
      overflow: hidden;
      .bdc-exam {
        position: relative;
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        margin-top: 30px;
        font-size: 18px;
        line-height: 1.8;
        .item {
          box-sizing: border-box;
          display: flex;
          padding: 0 10px 0 20px;
          width: 50%;
          flex-direction: column;
          justify-content: space-between;
          .question {
            font-size: 18px;
          }
          .chxz-question {
            font-size: 24px;
            font-weight: 700;
          }
          .blank {
            margin-top: 20px;
            vertical-align: sub;
          }
          .options {
            margin-top: 10px;
            padding-left: 20px;
            line-height: 1.5;
          }
          // div:nth-child(2) {
          //   margin-top: 6px!important;
          // }
          div:last-child {
            margin-bottom: 20px;
          }
        }
      }
      .quizze {
        margin-top: 5px;
        .radio-wrapper {
          .letter {
            border: none;
            font-weight: 700;
          }
        }
      }
    }
    .answer {
      display: none;
      width: 960px;
      margin: 40px auto 20px;
      word-break: break-all;
      font-size: 18px;
      line-height: 30px;
    }
    .print-exam-btn {
      position: fixed;
      width: 100px;
      top: 100px;
      right: 150px;
    }
    .print-answer-btn {
      position: fixed;
      width: 100px;
      top: 160px;
      right: 150px;
    }
    @media print {
      body {
        background-color: #fff;
      }
      .hide {
        display: none;
      }
      .display-answer {
        display: block!important;
      }
      .print-exam-btn, .print-answer-btn {
        display: none;
      }
    }
  }
</style>
